import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ShowContainer from './ShowContainer';

export const ImageFallback = ({ src, fallbackSrc, alt = 'Image' }) => {
  const { t } = useTranslation();
  const [hasError, setHasError] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(src);
  const timerRef = useRef();

  const handleError = () => {
    if (fallbackSrc && !hasError) {
      setCurrentSrc(fallbackSrc);
      setHasError(true);
    } else {
      setHasError(true);
    }
  };

  // useEffect(() => {
  //   setHasError(false);
  //   timerRef.current = setTimeout(() => setHasError(true), 2000);

  //   return () => clearTimeout(timerRef.current);
  // }, [src]);

  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      maxWidth={500}
      maxHeight={500}>
      {hasError && !fallbackSrc ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="100%"
          color="#999">
          <BrokenImageIcon style={{ fontSize: 48, marginBottom: 8 }} />
          <Typography>{t('Image not available')}</Typography>
        </Box>
      ) : (
        <img
          src={currentSrc}
          alt={alt}
          style={{
            maxWidth: '500px',
            maxHeight: '500px',
            objectFit: 'contain'
          }}
          onError={handleError}
          loading="lazy"
        />
      )}
    </Box>
  );
};
